import { getInstance } from '@portal/repositories/securitySdkConfig';

const BASE_URL = '/salary-portability-favored';

const SalaryPortability = {
  getFavored: async () => {
    const instance = getInstance();
    const { data } = await instance.get<{
      favored: models.ExternalContact | null;
    }>(BASE_URL);

    return data;
  },

  createFavored: async (
    favored: models.ExternalContact | models.PixContact
  ) => {
    const instance = getInstance();
    await instance.post(BASE_URL, { favored });
  },

  updateFavored: async (
    favored: Omit<models.ExternalContact, 'accountFavoredId' | 'pixKey'>
  ) => {
    const instance = getInstance();
    await instance.put(BASE_URL, { favored });
  },

  deleteFavored: async () => {
    const instance = getInstance();
    await instance.delete(BASE_URL);
  },
};

export default SalaryPortability;
